module.exports = "<div class=\"time-picker\">\n  <mat-icon class=\"calendar-icon\">schedule</mat-icon>\n\n  <mat-select [(value)]=\"selectedTime\" (change)=\"onSelectedTimeChanged($event)\">\n    <mat-option *ngFor=\"let time of sessionTimes\" [value]=\"time\">\n      <span *ngIf=\"!showEndOfTimeSession\">\n      {{ time.startTime | toPersianTime }}\n        </span>\n           <span *ngIf=\"showEndOfTimeSession\">\n      {{ time.endTime | toPersianTime }}\n        </span>\n    </mat-option>\n  </mat-select>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/time-picker/time-picker.component.html
// module id = 960
// module chunks = 3